export let CalendarGridTimeEventPlaceholderCssVars = /*#__PURE__*/function (CalendarGridTimeEventPlaceholderCssVars) {
  CalendarGridTimeEventPlaceholderCssVars["yPosition"] = "--y-position";
  CalendarGridTimeEventPlaceholderCssVars["height"] = "--height";
  return CalendarGridTimeEventPlaceholderCssVars;
}({});